import Vue from 'vue';
import Cart from '@/models/Cart';

const CartPlugin = {
  install(VueObj, options) {
    VueObj.prototype.$cart = new Cart();
  }
};

Vue.use(CartPlugin);